import BasicButton from "@components/button/BasicButton";
import BackHeader from "@components/header/BackHeader";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { queryClient } from "@libs/reactQuery/queryClient";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import { Flex } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

const Container = styled.div(({ theme }) => ({
  padding: "2rem",
  backgroundColor: theme.color.white,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minHeight: "calc(100vh - 5.6rem)",
  position: "relative",
  justifyContent: "center",
}));

const ContentWrapper = styled.div({
  maxWidth: "48rem",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  // marginTop: "22.6rem",
});

const Title = styled.div(({ theme }) => ({
  fontSize: "2.4rem",
  marginBottom: "4.8rem",
  textAlign: "center",
  fontWeight: theme.fontWeight.medium,
}));

const MessageBox = styled.div(({ theme }) => ({
  width: "100%",
  marginBottom: "3rem",
  // fontWeight: theme.fontWeight.bold,
}));

const MessageItem = styled.li(({ theme }) => ({
  fontSize: "1.4rem",
  color: theme.color.gray,
  lineHeight: "2.4rem",
  position: "relative",
  paddingLeft: "2.6rem",
  display: "flex",
  flexDirection: "column",

  "&:before": {
    content: '"•"',
    position: "absolute",
    left: 10,
  },

  "&:last-child": {
    marginBottom: 0,
  },
}));

const Date = styled.div(({ theme }) => ({
  fontSize: "1.4rem",
  color: theme.color.gray,
  lineHeight: "2.4rem",
  fontWeight: theme.fontWeight.bold,
}));

const ButtonWrapper = styled.div({
  padding: "0 2rem",
  width: "100%",
  position: "absolute",
  bottom: "4.8rem",
});

const SubscribeSuccess = () => {
  const { postAddMemberSubscription, getMemberSubscription } = useApiRequest();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();
  const lang = localStorage.getItem("language");

  const { mutate } = useMutation({
    mutationFn: (data) => postAddMemberSubscription(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["subscribeDetail"]);
      queryClient.invalidateQueries(["subscribeDetailList"]);
    },
    onError: () => {
      navigate("/subscribe-fail");
    },
  });

  const { data: subscribeDetail } = useQuery({
    queryKey: ["subscribeDetail"],
    queryFn: () => getMemberSubscription(),
  });

  useEffect(() => {
    const customerKey = searchParams.get("customerKey");
    const authKey = searchParams.get("authKey");

    if (!customerKey || !authKey) {
      return;
    }

    mutate({ customer_key: customerKey, auth_key: authKey });
  }, [searchParams]);

  const formatEnglishDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "Invalid Date"; // 유효성 검사 추가

    const [year, month, day] = dateStr.split("-");
    if (!year || !month || !day) return "Invalid Date"; // 형식이 올바르지 않으면 기본값 반환

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return `${months[parseInt(month, 10) - 1]} ${parseInt(day, 10)}, ${year}`;
  };

  return (
    <>
      <BackHeader title="구독" />

      <Container>
        <ContentWrapper>
          <Flex vertical align="center" gap={"4rem"}>
            <Image
              src={theme.image.check_circle.default}
              width="6rem"
              height="6rem"
            />
            <Title>{t("결제가 완료되었습니다")}</Title>
          </Flex>

          <ButtonWrapper>
            <MessageBox>
              <MessageItem>
                {/* <Date> */}
                {lang === "ko"
                  ? `${subscribeDetail?.start_date} ~ ${subscribeDetail?.next_payment_date}까지 이용할 수 있습니다.`
                  : `You can use it from ${formatEnglishDate(subscribeDetail?.start_date)} to ${formatEnglishDate(subscribeDetail?.next_payment_date)}.`}
                {/* </Date> */}
              </MessageItem>
              <MessageItem>{t("구독은 매월 자동결제 됩니다.")}</MessageItem>
            </MessageBox>

            <BasicButton
              title="상품 구매하러 가기"
              width="100%"
              onClick={() => navigate("/")}
              height="5.2rem"
            />
          </ButtonWrapper>
        </ContentWrapper>
      </Container>
    </>
  );
};

export default SubscribeSuccess;
